import { Link, NavLink, useNavigate } from "react-router-dom";
import { DropdownButton } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useEffect, useState } from "react";
import hasRole from "../../utils/functions/hasRole";
import styles from "./index.module.scss";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  logout,
  searchProduct,
  setLoginModal,
  setRegistrationModal,
} from "../../redux/reducers";
import {
  getCartState,
  getIsAuth,
  getRegistrationModal,
} from "../../redux/selectors";
import api from "../../api";
import DropdownItem from "react-bootstrap/esm/DropdownItem";

interface ICatalogProps {
  catalogTypeId: number;
  index: number;
  catalogName: string;
}
const Navbar = () => {
  const [catalogs, setCatalogs] = useState<ICatalogProps[]>([]);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const modal = useAppSelector((state) => getRegistrationModal(state));
  const cart = useAppSelector((state) => getCartState(state));
  const isAuth = useAppSelector((state) => getIsAuth(state));

  const [resNav, setResNav] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [cartAmount, setCartAmount] = useState<number>(0);
  const counter = () => {
    let ctr = 0;
    cart.forEach((e) => {
      ctr += e.amount * 1;
    });

    setCartAmount(ctr);
  };
  useEffect(() => {
    api.allCatalogTypes().then((res) => {
      setCatalogs(res);
    });
  }, []);
  const handleOpenNav = () => {
    setResNav(true);
  };

  const handleCloseNav = () => {
    setResNav(false);
  };

  const search = () => {
    dispatch(searchProduct(inputValue)).then(() => navigate("/search"));
  };

  const isAdmin = hasRole("admin");
  useEffect(() => {
    counter();
  }, [cart]);
  const onLogout = () => {
    // @ts-ignore
    dispatch(logout());
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className="container">
          <div className={styles.top}>
            <Link to="">
              <h5>Яркуткс</h5>
            </Link>
            <Link to="">
              <h5>Помощь</h5>
            </Link>
            {isAdmin ? (
              <Link to="/admin">
                <h5>Админ</h5>
              </Link>
            ) : !isAuth ? (
              <h5
                onClick={() => {
                  dispatch(setLoginModal());
                }}
              >
                Вход
              </h5>
            ) : (
              <h5 onClick={onLogout}>Выйти</h5>
            )}
          </div>
          <div className={styles.main}>
            <Link to="/" className={styles.navTitle}>
              <i onClick={handleOpenNav} className="fa-solid fa-bars" />
              <h3>Tamara</h3>
            </Link>
            <div className={styles.input}>
              <DropdownButton
                id={styles.button}
                title={<i className="fa-solid fa-bars" />}
              >
                {catalogs.length == 0 ? (
                  <DropdownItem>Загрузка Каталогов</DropdownItem>
                ) : (
                  catalogs.map((e) => (
                    <DropdownItem key={e.catalogTypeId}>
                      <Link to={"catalog/" + e.catalogName}>
                        {e.catalogName}
                      </Link>
                    </DropdownItem>
                  ))
                )}
              </DropdownButton>
              <input
                type="text"
                placeholder="Номер детали, VIN. Пример — 1234567"
                onChange={(e) => setInputValue(e.target.value)}
                value={inputValue}
              />
              <button
                onClick={search}
                className={styles.search + " " + styles.button}
              >
                Найти
              </button>
            </div>
            <Link to="/basket" className={styles.cart}>
              <i className="fa-solid fa-cart-shopping" />
              Корзина
              <sub>{cartAmount}</sub>
            </Link>
          </div>
        </div>
      </nav>
      <div
        className={`${styles.responsiveNav} ${resNav ? styles.showResNav : ""}`}
      >
        <div className="d-flex justify-content-between">
          <i className="fa-solid fa-xmark" onClick={handleCloseNav} />
          <button
            onClick={() => {
              dispatch(setRegistrationModal());
              console.log(modal);
            }}
          >
            Вход
          </button>
        </div>
      </div>
      {/* {modalActive ? <LoginModal /> : <></>} */}
    </>
  );
};
export default Navbar;
